import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DndForwardslashIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dnd_forwardslash"}/>
}
